import React, { useEffect, useState, useRef, useMemo } from "react";
import {
  Button,
  Tabs,
  message,
  Form,
  Input,
  Upload,
  Select,
  Table,
  Space,
  Modal,
  Divider,
  Checkbox,
  Progress,
} from "antd";
import type { RcFile, UploadFile, UploadProps } from "antd/es/upload/interface";
import type { UploadChangeParam } from "antd/es/upload";
import type { ColumnsType } from "antd/es/table";
import type { CheckboxProps, TabsProps } from "antd";
import {
  LoadingOutlined,
  PlusSquareFilled,
  CloudUploadOutlined,
  CloseCircleFilled,
  CheckCircleFilled,
} from "@ant-design/icons";
import { useParams, useOutletContext } from "react-router-dom";
import { cloneDeep, debounce, delay } from "lodash-es";
import { useSelector } from "react-redux";
import StickyBox from "react-sticky-box";
import api from "@/api";
import {
  format,
  findDeep,
  changeSize,
  getReleaseDetail,
  arraysAreEqual,
  resetFormValidate,
  validateFormField,
  getType,
  parseResponseToArray,
} from "@/utils";
import { appNameReg } from "@/utils/constant";
import { uploadBaseUrl } from "@/api/release";
import ApplyDown from "./ApplyDown";

import dataJson from "@/../public/data.json";

const prefix = "version_manage";
import "./index.less";
import { getAuthTokenValue } from "@kaihong/utils/lib/khAuthToken";
import http from "@/api/http";
import { CustomItem, RenderCustomCompenentProps } from "@/types";

const VersionManage: React.FC = () => {
  const { type, id } = useParams();
  const { isTampered = false } = useOutletContext<{ isTampered?: boolean }>() || {};
  const {
    release,
    staging,
    app_detail,
    please_enter,
    icon_text,
    one_bars,
    two_bars,
    please_upload,
    save_text,
    save_success_text,
    req_err,
    cancelText,
    confirmText,
    increase,
    clear_text,
    asterisk,
    name_label,
    description_label,
    please_choose,
    app_list,
  } = dataJson;
  const [activeKey, setActiveKey] = useState("1");
  const [previewData, setPreviewData] = useState<any[]>([]);
  const [iconLoading, setIconLoading] = useState(false);
  const [iconImageUrl, setIconImageUrl] = useState<string>();
  const [domainOption, setDomainOption] = useState<any[]>([]);
  const [kaihongOSVersionOption, setKaihongOSVersionOption] = useState<any[]>([]);
  const [topicOption, setTopicOption] = useState<any[]>([]);
  const [tableData, setTableData] = useState<any[]>(release.table_init);
  const [selectedKeys, setSelectedKeys] = useState<any[]>([]);
  const dataSource = useRef<any[]>(release.table_init); // 所有table数据，软件包类型切换时候只对应其中的部分内容展示，注意记录所有项的选中效果
  const detailData = useRef<any>();

  const packageType = useRef<string>("");
  const [packageData, setPackageData] = useState<any>();
  const [packageLoading, setPackageLoading] = useState(false);
  const [copyrightImage, setCopyrightImage] = useState<any[]>([]);
  const [copyrightLoading, setCopyrightLoading] = useState(false);
  const [isBaseFinish, setIsBaseFinish] = useState(false);
  const [isVersionFinish, setIsVersionFinish] = useState(false);
  const [uploadProgress, setUploadProgress] = useState<number>(0);

  const [applyDownVisible, setApplyDownVisible] = useState(false);

  const [savaLoading, setSavaLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [cancelReleaseLoading, setCancelReleaseLoading] = useState(false);
  const [cancelDownLoading, setCancelDownLoading] = useState(false);

  const releaseDetail = useSelector((state: any) => state.releaseDetail);
  const userData = useSelector((state: any) => state.userData);

  const [customContent, setCustomContent] = useState<CustomItem[]>([]);

  const previewInit = release.table_init.map((item: any) => ({
    key: item.key,
    title: item.title,
    description: "",
    osIds: [],
    list: [],
  }));
  const preview = useRef<any[]>(previewInit); // 存放所有预览图信息

  const [baseForm] = Form.useForm();
  const baseFormValues = Form.useWatch([], baseForm);
  const baseFinishFields = useMemo(() => {
    const customKeys = (customContent || []).map((c: any) => c?.key).filter(Boolean);
    return [
      "previewFormData",
      "name",
      "introduction",
      "description",
      "iconResources",
      "domain",
      "topic",
      "system",
      ...customKeys,
    ];
  }, [customContent]);

  const [versionForm] = Form.useForm();
  const versionFormValues = Form.useWatch([], versionForm);

  const uploadUrl = `${uploadBaseUrl}/app/upload/public/${id}`;

  const { packageTypeErrPrefix, packageTypeErrSuffix, packageSizeErr } = app_detail;
  const typeObj: any = app_detail.type_obj;
  const typeItem = typeObj[getType(type!)];
  const systemOptions: any = app_detail.system_arr;
  const appTypes = useSelector((state: any) => state.appTypes);

  const onChange = (key: string) => {
    setActiveKey(key);
  };

  const renderBtn = (item: string) => {
    const newShowMode =
      detailData.current?.histories?.length > 1 && detailData.current?.histories[0]?.showMode === "AUDIT_UPGRADE";
    switch (item) {
      case "save":
        return (
          <Button
            type="primary"
            loading={savaLoading}
            ghost
            style={{ marginLeft: "16px" }}
            disabled={isTampered}
            onClick={handleSave}
          >
            {save_text}
          </Button>
        );
      case "submitReview":
        return (
          <Button
            type="primary"
            loading={submitLoading}
            style={{ marginLeft: "16px" }}
            disabled={isTampered}
            onClick={submitReview}
          >
            {release.submit_review}
          </Button>
        );
      case "cancelRelease":
        return (
          <Button type="primary" style={{ marginLeft: "16px" }} disabled={isTampered} onClick={cancelRelease}>
            {release.cancel_release}
          </Button>
        );
      // case "upgrade":
      //   // 未升级情况，下架审核中的状态没有版本提交按钮，已升级的情况，下架审核中的状态有版本提交按钮，点击后跳转到新版本
      //   if (detailData.current?.histories?.length == 1 && detailData.current?.showMode === "AUDIT_DOWN") {
      //     break;
      //   }
      //   return (
      //     <Button type="primary" style={{ marginLeft: "16px" }} onClick={upgrade}>
      //       {release.upgrade}
      //     </Button>
      //   );
      case "down":
        if (newShowMode) {
          break;
        }
        return (
          <Button
            type="primary"
            ghost
            style={{ marginLeft: "16px" }}
            disabled={isTampered}
            onClick={() => {
              setApplyDownVisible(true);
            }}
          >
            {release.audit_down}
          </Button>
        );
      case "cancelDown":
        return (
          <Button type="primary" style={{ marginLeft: "16px" }} disabled={isTampered} onClick={cancelDown}>
            {release.cancel_down}
          </Button>
        );
      default:
        return;
    }
  };

  const renderTabBar: TabsProps["renderTabBar"] = (props, DefaultTabBar) => (
    <StickyBox offsetTop={0} offsetBottom={20} style={{ zIndex: 99, background: "#fff", paddingTop: 24 }}>
      <DefaultTabBar {...props} />
    </StickyBox>
  );

  // 校验用户名
  const validateName = (_: any, value: any) => {
    if (value) {
      if (value !== detailData.current.name) {
        return api.allRepeatName({ name: value }).then((resp: any) => {
          if (resp.code === 200) {
            if (resp.data?.exist) {
              return Promise.reject(new Error(app_list.name_already));
            }
          } else {
            return Promise.resolve();
          }
        });
      } else {
        return Promise.resolve();
      }
    } else {
      return Promise.resolve();
    }
  };

  // 预览数据从树状转化成平铺
  const flatPreviewData = (params: any) => {
    return new Promise<void>((resolve) => {
      const list: any = [];

      params?.forEach((item: any) => {
        item.list.forEach((ele: any) => {
          const reqOsIds = ele?.osIds?.map((item: any) => item[1]);
          const pictureIds = ele?.urlList?.map((e: any) => e.id);
          const obj = {
            description: ele?.description || "",
            osIds: reqOsIds || [],
            id: ele?.dictCode,
            pictureIds: pictureIds,
          };
          list.push(obj);
        });
      });
      const effectiveList = list.filter((item: any) => {
        // return item.description || item.pictureIds?.length > 0;
        return item?.osIds?.length || item?.pictureIds?.length;
      });
      resolve(effectiveList);
    });
  };

  const scrollErrDom = (domClass: string, delayTime?: number) => {
    if (delayTime) {
      delay(() => {
        const errorList = (document as any).querySelectorAll(domClass);
        //由于校验失败ant会自动给失败表单项添加类名，直接获取即可
        errorList[0].scrollIntoView({
          block: "center",
          behavior: "smooth",
        });
      }, delayTime);
    } else {
      const errorList = (document as any).querySelectorAll(domClass);
      //由于校验失败ant会自动给失败表单项添加类名，直接获取即可
      errorList[0].scrollIntoView({
        block: "center",
        behavior: "smooth",
      });
    }
  };

  // 处理请求参数
  const handleReq = async (isValidate: boolean) => {
    if (checkIsImgUploading()) {
      message.warning(release.upload_img_ing);
      return;
    } else if (packageLoading) {
      message.warning(release.upload_package_ing);
      return;
    }

    let baseValues: any;
    let versionValues: any;
    let versionValuesClean: any;

    if (isValidate) {
      if (activeKey === "1") {
        try {
          baseValues = await baseForm.validateFields();
        } catch (error) {
          scrollErrDom(".ant-form-item-has-error", 100);
          return;
        }

        if (baseValues) {
          try {
            versionValues = await versionForm.validateFields();
          } catch (error) {
            setActiveKey("2");
            scrollErrDom(".ant-form-item-has-error", 300);
            return;
          }
        }
      } else {
        try {
          baseValues = await baseForm.validateFields();
        } catch (error) {
          setActiveKey("1");
          scrollErrDom(".ant-form-item-has-error", 300);
          return;
        }
        if (baseValues) {
          try {
            versionValues = await versionForm.validateFields();
          } catch (error) {
            scrollErrDom(".ant-form-item-has-error", 100);
            return;
          }
        }
      }
    } else {
      // 应用名称保存校验
      if (
        baseFormValues.name == undefined ||
        baseFormValues.name == null ||
        baseFormValues.name == "" ||
        (!(baseFormValues.name == undefined || baseFormValues.name == null || baseFormValues.name == "") &&
          (await validateFormField({ form: baseForm, name: "name" })))
      ) {
        setActiveKey("1");

        resetFormValidate([
          { form: baseForm, formValues: baseFormValues },
          { form: versionForm, formValues: versionFormValues },
        ]);
        baseForm.validateFields(["name"]);
        scrollErrDom(".ant-form-item-has-error", 500);
        return;
      }
      // 隐私声明存在 但不符合填写规范不能保存
      if (
        !(
          versionFormValues.privacy == undefined ||
          versionFormValues.privacy == null ||
          versionFormValues.privacy == ""
        ) &&
        (await validateFormField({ form: versionForm, name: "privacy" }))
      ) {
        setActiveKey("2");
        await resetFormValidate([
          { form: baseForm, formValues: baseFormValues },
          { form: versionForm, formValues: versionFormValues },
        ]);
        versionForm.validateFields(["privacy"]);
        scrollErrDom(".ant-form-item-has-error", 500);
        return;
      }
      baseValues = await baseForm.getFieldsValue();
      versionValues = await versionForm.getFieldsValue();
    }

    try {
      // 承诺函仅用于前端校验/完成态，不参与后端入参
      const { commitmentAgree, ...restVersionValues } = versionValues || {};
      versionValuesClean = restVersionValues;
      const supportDevices = await flatPreviewData(previewData);
      const resourcesArr = [];
      const copyrightIds = versionValuesClean?.copyright?.map((item: any) => item.id);
      copyrightIds?.length &&
        resourcesArr.push({
          resourceIds: copyrightIds,
          type: "CERTIFICATE_PICTURE",
        });
      const iconIds = baseValues?.iconResources;
      !!iconIds &&
        resourcesArr.push({
          resourceIds: [iconIds],
          type: "ICON",
        });
      let customJson;
      if (detailData.current?.customContent && Array.isArray(detailData.current.customContent)) {
        const arr = detailData.current.customContent.map((item: any) => {
          const fieldName = item.key;
          if (fieldName) {
            item.value = baseValues?.[fieldName] || undefined;
          }
          return item;
        });
        if (arr.length > 0) {
          customJson = JSON.stringify({ config: arr });
        }
      }
      const kaihongOSVersionId = versionValuesClean?.kaihongOSVersionId;
      const supportOS =
        kaihongOSVersionId == null || kaihongOSVersionId === ""
          ? undefined
          : kaihongOSVersionId === "NO_RELATE"
          ? {}
          : {
              id: kaihongOSVersionId,
              supportType: versionValuesClean?.kaihongOSVersionType,
            };
      const req = {
        description: baseValues?.description,
        domain: baseValues?.domain ? [baseValues?.domain] : [],
        topic: baseValues?.topic,
        id: id,
        name: baseValues?.name,
        introduction: baseValues?.introduction,
        instanceIds: versionValuesClean?.instanceIds?.instanceId ? [versionValuesClean?.instanceIds?.instanceId] : [],
        privacy: versionValuesClean?.privacy,
        resources: resourcesArr,
        supportDevices,
        supportOS,
        system: baseValues?.system,
        customJson: customJson || undefined,
      };
      console.log(req);
      return req;
    } catch (errorInfo: any) {
      console.error(errorInfo);
      return;
    }
  };

  const handleSave = async () => {
    try {
      const req = await handleReq(false);
      if (req) {
        try {
          setSavaLoading(true);
          const res: any = await api[typeItem.saveApi](req);
          setSavaLoading(false);
          if (res?.code == 200) {
            getReleaseDetail(type, id);
            message.success(save_success_text);
          } else {
            message.error(res.msg);
          }
        } catch (errorInfo: any) {
          setSavaLoading(false);
          message.error(errorInfo?.response?.data?.msg || req_err);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  // 提交审核
  const submitReview = debounce(async () => {
    if (versionForm.getFieldValue("commitmentAgree") !== true) {
      // 仅触发表单项的校验提示，避免重复弹窗提示
      versionForm.validateFields(["commitmentAgree"]);
      if (activeKey === "1") {
        setActiveKey("2");
        scrollErrDom(`.${prefix}-versionForm-agree`, 300);
      } else {
        scrollErrDom(`.${prefix}-versionForm-agree`);
      }
      return;
    }
    const req = await handleReq(true);

    if (req) {
      try {
        setSubmitLoading(true);
        const res: any = await api[typeItem.nextSaveApi](req);
        setSubmitLoading(false);
        if (res?.code == 200) {
          // 接口要区分是否是升级的提交
          const res2: any = await api[
            detailData.current?.isUpgrade ? typeItem.auditUpgradeApi : typeItem.auditReleaseApi
          ]({ id: id });
          if (res2?.code == 200) {
            message.success(release.wait_review);
            getReleaseDetail(type, id);
          } else {
            message.error(res2.msg);
          }
        } else {
          message.error(res.msg);
        }
      } catch (errorInfo: any) {
        setSubmitLoading(false);
        message.error(errorInfo?.response?.data?.msg || req_err);
      }
    }
  }, 300);

  const cancelRelease = async () => {
    const modal = Modal.confirm({
      icon: null,
      centered: true,
      closable: true,
      width: 350,
      title: release.cancel_release_title,
      content: release.cancel_release_content,
      footer: (
        <div style={{ textAlign: "right", marginTop: "20px" }}>
          <Button
            type="primary"
            ghost
            onClick={() => {
              modal.destroy();
            }}
          >
            {cancelText}
          </Button>
          <Button
            type="primary"
            style={{ marginLeft: "24px" }}
            loading={cancelReleaseLoading}
            onClick={async () => {
              try {
                setCancelReleaseLoading(true);
                const res: any = await api[
                  detailData.current?.isUpgrade ? typeItem.cancelUpgradeApi : typeItem.cancelReleaseApi
                ]({ id: id });
                setCancelReleaseLoading(false);
                if (res?.code == 200) {
                  message.success(release.cancel_release_success);
                  getReleaseDetail(type, id);
                  modal.destroy();
                } else {
                  message.error(res.msg);
                }
              } catch (errorInfo: any) {
                setCancelReleaseLoading(false);
                message.error(errorInfo?.response?.data?.msg || req_err);
              }
            }}
          >
            {confirmText}
          </Button>
        </div>
      ),
    });
  };

  const cancelDown = async () => {
    const modal = Modal.confirm({
      icon: null,
      centered: true,
      closable: true,
      width: 350,
      title: release.cancel_down,
      content: release.cancel_down_content,
      footer: (
        <div style={{ textAlign: "right", marginTop: "20px" }}>
          <Button
            type="primary"
            ghost
            onClick={() => {
              modal.destroy();
            }}
          >
            {cancelText}
          </Button>
          <Button
            type="primary"
            loading={cancelDownLoading}
            style={{ marginLeft: "24px" }}
            onClick={async () => {
              try {
                setCancelDownLoading(true);

                const res: any = await api[typeItem.cancelDownApi]({ id: id });
                setCancelDownLoading(false);
                if (res?.code == 200) {
                  message.success(release.cancel_down_success);
                  getReleaseDetail(type, id);
                  modal.destroy();
                } else {
                  message.error(res.msg);
                }
              } catch (errorInfo: any) {
                setCancelDownLoading(false);
                message.error(errorInfo?.response?.data?.msg || req_err);
              }
            }}
          >
            {confirmText}
          </Button>
        </div>
      ),
    });
  };
  const applyDownClose = () => {
    setApplyDownVisible(false);
    getReleaseDetail(type, id);
  };

  // 设置全数据
  const setPreviewCurrent = (params: any) => {
    const newPreview = preview.current.map((item: any) => {
      const previewItem = params?.find((ele: any) => item.key == ele.key);
      return previewItem ? previewItem : item;
    });

    preview.current = newPreview.filter((item: any) => Object.prototype.toString.call(item) != "[object String]");
  };

  // 初始化数据
  const initHandle = async (tableParams: any[]) => {
    const dataCopy = cloneDeep(detailData.current);

    let packObj = null;
    packObj = dataCopy?.appInstances?.length
      ? {
          ...dataCopy?.appInstances[0]?.packageResource,
          version: dataCopy?.appInstances[0]?.version,
          instanceId: dataCopy?.appInstances[0]?.instanceId,
        }
      : null;

    const iconItem = dataCopy?.resources?.find((item: any) => item.type == "ICON");

    const hasPreviewFormData = !!dataCopy?.support?.compatibilities?.length;

    const tableDataCopy = cloneDeep(tableParams);
    const newTableDataCopy = tableDataCopy.map((item: any) => {
      const itemList = dataCopy?.support?.compatibilities?.filter((ele: any) => ele.type == item.key) || [];
      const idList = itemList?.map((ele: any) => ele.id);
      if (idList?.length) {
        item.compatibleDevices = idList;
      }
      return item;
    });
    dataSource.current = newTableDataCopy;

    const list = newTableDataCopy.filter((item: any) => {
      return item.key !== "platform_BIG";
    });
    const initTableData: any[] = tableDataCopy.map((item: any) => {
      const itemList = dataCopy?.support?.compatibilities?.filter((ele: any) => ele?.type == item?.key) || [];

      const objList = itemList.map((ele: any) => {
        const objUrlList = ele.resources.map((e: any) => {
          return {
            id: e.id,
            url: e.url,
            loading: false,
          };
        });
        const osIdsArr = ele.osVersions?.map((e: any) => [e.type, e.id]);

        const objItem = {
          dictCode: ele.id || "",
          loading: false,
          title: ele?.title || "",
          description: ele?.description || "",
          osIds: osIdsArr || [],
          urlList: objUrlList,
        };
        return objItem;
      });

      const obj = {
        key: item.key,
        title: item.title,
        list: objList,
      };
      return obj;
    });

    const initPreviewData = initTableData?.filter((item: any) => item?.list?.length);
    setPreviewCurrent(initPreviewData);
    let initSelectedKeys = initPreviewData.map((item: any) => item.key);
    if (!hasPreviewFormData) {
      initSelectedKeys = [list[0].key];
    }

    const copyrightList = dataCopy.resources
      .filter((item: any) => item.type == "CERTIFICATE_PICTURE")
      .map((item: any) => ({ id: item.id, url: item.url }));

    const customFormValues: any = {};
    if (dataCopy?.customContent && Array.isArray(dataCopy.customContent)) {
      dataCopy.customContent.forEach((item: any) => {
        const fieldName = item.key;
        if (fieldName) {
          let value;
          if (dataCopy.customJson) {
            const arr = parseResponseToArray(dataCopy.customJson);
            value = arr.find((_item: any) => _item.key === fieldName)?.value;
          }
          customFormValues[fieldName] = value;
        }
      });
    }

    baseForm.setFieldsValue({
      name: dataCopy?.name || "",
      introduction: dataCopy?.introduction || "",
      description: dataCopy?.description || "",
      iconResources: iconItem?.id || "",
      domain: dataCopy?.domain?.length ? dataCopy?.domain[0] : undefined,
      topic: dataCopy?.topic || [],
      previewFormData: [],
      system: dataCopy?.system || [],
      ...customFormValues,
    });

    versionForm.setFieldsValue({
      instanceIds: packObj,
      iconResources: iconItem?.id || "",
      privacy: dataCopy?.privacy,
      commitmentAgree: !!dataCopy?.disabled,
      copyright: copyrightList,
      kaihongOSVersionId: dataCopy?.support?.osCompatibility
        ? dataCopy?.support?.osCompatibility.id
          ? dataCopy?.support?.osCompatibility.id
          : "NO_RELATE"
        : undefined,
      kaihongOSVersionType: dataCopy?.support?.osCompatibility?.supportType,
    });

    setPackageData(packObj);
    setIconImageUrl(iconItem?.url);
    setSelectedKeys(initSelectedKeys);
    setTableData(list);
    setCopyrightImage(copyrightList);
    // setPreviewData(initPreviewData);
  };

  // 获取不同设备类型的可兼容设备
  const getSupportOptions = () => {
    const typeList = release.table_init.map((item: any) => item.key);
    const hasPreviewFormData = !!releaseDetail?.support?.compatibilities?.length;
    const promises = typeList.map(async (item: any) => {
      return await getOptions(item);
    });

    Promise.all(promises)
      .then(async (posts) => {
        const tableCopy = cloneDeep(release.table_init).map((item: any, index: number) => {
          // 初始值，默认选中第一行第一项
          // if (!hasPreviewFormData && ["platform_BIG", "platform_3C"].includes(item.key)) {
          if (!hasPreviewFormData && ["platform_3C"].includes(item.key)) {
            item.checked = true;
            item.compatibleDevices = [posts[index][0].dictCode];
          }
          return {
            ...item,
            options: posts[index],
          };
        });
        initHandle(tableCopy);
      })
      .catch(() => {
        // ...
      });
  };

  // 可兼容设备改变事件，注意对应设备类型和列表的row数据
  const compatibleChange = (value: string[], key: string) => {
    const tableDataCopy = cloneDeep(tableData);
    const newData = tableDataCopy.map((item: any) => {
      if (key == item.key) {
        item.compatibleDevices = value;
      }
      return item;
    });
    setTableData(newData);
  };

  // table列
  const getTableColumns: () => ColumnsType<any> = () => {
    const tableColumns = cloneDeep(release.table_columns);
    const columnsList = tableColumns.map((item: any) => {
      if (item.dataIndex === "compatibleDevices") {
        return {
          ...item,
          render: (_: any, record: any) => {
            return (
              <Space size="middle" key={record.key}>
                <Select
                  mode="multiple"
                  showSearch={false}
                  value={_}
                  style={{ minWidth: "80px" }}
                  dropdownStyle={{ minWidth: 150 }}
                  placeholder={increase}
                  fieldNames={{ label: "dictLabel", value: "dictCode" }}
                  onChange={(e) => {
                    compatibleChange(e, record.key);
                  }}
                  options={record.options}
                  tagRender={(params) => {
                    // 多选时候每个选项选中后对应展示的内容
                    const le = record?.compatibleDevices?.length || 0;
                    const text =
                      record?.compatibleDevices[le - 1] == params.value ? params.label : params.label + "\xa0/\xa0";
                    return <span>{text}</span>;
                  }}
                  disabled={!selectedKeys.includes(record.key) || detailData.current?.disabled}
                  className={`${prefix}-device-select`}
                  popupClassName={`${prefix}-device-select-popup`}
                />
              </Space>
            );
          },
        };
      } else if (item.dataIndex === "action") {
        return {
          ...item,
          render: (_: any, record: any) => {
            const tableDataCopy = cloneDeep(tableData);
            const tableChecks = tableDataCopy.filter((item: any) => selectedKeys?.includes(item.key));
            const allCompatibleDevices = tableChecks.reduce((pre: any, cur: any) => {
              return [...pre, ...cur.compatibleDevices];
            }, []);
            const checkDisabled = arraysAreEqual(allCompatibleDevices, record.compatibleDevices); // 选中的所有可兼容设备被都在当前选中行

            return (
              <Space size="middle" key={record.key}>
                <Button
                  type="link"
                  onClick={() => {
                    compatibleChange([], record.key);
                  }}
                  disabled={checkDisabled || detailData.current?.disabled}
                >
                  {clear_text}
                </Button>
              </Space>
            );
          },
        };
      } else {
        return item;
      }
    });
    return columnsList;
  };

  // 多选事件
  const rowSelection = {
    // 对应的选项
    selectedRowKeys: selectedKeys,
    // 选中项发生变化时
    onChange: (selectedRowKeys: React.Key[]) => {
      setSelectedKeys(selectedRowKeys);
    },
    // 手动选择/取消选择某行
    onSelect: (record: any, selected: any) => {
      dataSource.current.forEach((item: any) => {
        if (record.key == item.key) {
          item.checked = selected;
        }
      });
    },
    // 手动选择/取消选择所有行
    onSelectAll: (selected: any, selectedRows: any, changeRows: any) => {
      dataSource.current.forEach((item: any) => {
        if (changeRows.key == item.key) {
          item.checked = !item.checked;
        }
      });
    },
    getCheckboxProps: (record: any) => {
      let checkDisabled = false;
      const oneCheck = selectedKeys.length === 1; //只有一行被选中
      if (oneCheck) {
        const thisCheck = selectedKeys[0] === record.key; //选中的是当前这行
        checkDisabled = oneCheck && thisCheck; // 仅有一个选中时候不允许取消，保证有一个选中
      } else {
        const tableDataCopy = cloneDeep(tableData);
        const tableChecks = tableDataCopy.filter((item: any) => selectedKeys?.includes(item.key));
        const allCompatibleDevices = tableChecks.reduce((pre: any, cur: any) => {
          return [...pre, ...cur.compatibleDevices];
        }, []);
        checkDisabled = arraysAreEqual(allCompatibleDevices, record.compatibleDevices); // 选中的所有可兼容设备被都在当前选中行
      }

      return {
        disabled: detailData.current?.disabled || checkDisabled,
      };
    },
  };

  // 图片上传前处理
  const beforeUpload: any = (file: RcFile, { width, height, size, accept = ["png"] }: any) => {
    return new Promise<void>((resolve, reject) => {
      const isAccept = accept.some((item: string) => file.type === `image/${item}`);
      const acceptText = accept.join("、").toUpperCase();

      if (!isAccept) {
        message.error(
          `${release.upload_accept_err.text1}${width}${asterisk}${height}${release.upload_accept_err.text2}${acceptText}${release.upload_accept_err.text3}`
        );
        reject();
        return;
      }
      if (size) {
        const imgSize = file.size;
        if (imgSize > size) {
          const sizeText = changeSize(size);
          message.error(`${release.upload_size_err.text1}${sizeText}${release.upload_size_err.text2}`);
          reject();
          return;
        }
      }
      const _URL = window.URL || window.webkitURL;
      const img = new Image();
      img.src = _URL.createObjectURL(file);

      img.onerror = () => {
        message.error(release.upload_fail);
      };
      img.onload = () => {
        if (img.width != width || img.height != height) {
          message.error(
            `${release.upload_accept_err.text1}${width}${asterisk}${height}${release.upload_accept_err.text2}${acceptText}${release.upload_accept_err.text3}`
          );
          reject();
        } else {
          resolve();
        }
      };
    });
  };

  // 上传证书
  const copyrightBeforeUpload = (file: RcFile) => {
    const isType = ["image/jpg", "image/jpeg", "image/bmp", "image/png"].includes(file.type);
    if (!isType) {
      message.error(release.upload_copyright_err.type);
    }
    const isLt2M = file.size / 1024 / 1024 <= 10;
    if (!isLt2M) {
      message.error(release.upload_copyright_err.size);
    }
    return isType && isLt2M;
  };

  // 图标新增
  const iconImageChange: UploadProps["onChange"] = (info: UploadChangeParam<UploadFile>) => {
    if (info.file.status === "uploading") {
      setIconLoading(true);
      return;
    } else {
      setIconLoading(false);
    }
    if (info.file.status === "done") {
      if (info.file.response.code === 200) {
        const iconUrl = info?.file?.response?.data?.url;
        const iconId = info?.file?.response?.data?.id;

        setIconLoading(false);
        setIconImageUrl(iconUrl);
        baseForm.setFieldValue("iconResources", iconId);
      } else {
        message.error(info.file.response.msg);
      }
    } else {
      baseForm.setFieldValue("iconResources", "");
      setIconImageUrl("");
    }
    baseForm.validateFields(["iconResources"]);
  };
  // 预览图更换
  const previewImgUpdate = (info: UploadChangeParam<UploadFile>, index: number, idx: number, i: number) => {
    const previewDataCopy = cloneDeep(previewData);
    if (info.file.status === "uploading") {
      previewDataCopy[index].list[idx].urlList[i].loading = true;
      setPreviewData(previewDataCopy);
      return;
    } else {
      previewDataCopy[index].list[idx].urlList[i].loading = false;
      setPreviewData(previewDataCopy);
    }
    if (info.file.status === "done") {
      if (info.file.response.code === 200) {
        previewDataCopy[index].list[idx].urlList[i].id = info?.file?.response?.data?.id;
        previewDataCopy[index].list[idx].urlList[i].url = info?.file?.response?.data?.url;
        previewDataCopy[index].list[idx].urlList[i].loading = false;
        setPreviewData(previewDataCopy);
      } else {
        message.error(info.file.response.msg);
      }
    } else {
      setPreviewData(previewDataCopy);
    }
    baseForm.validateFields(["previewFormData"]);
  };
  // 预览图删除
  const previewImgDelete = (index: number, idx: number, i: number) => {
    const previewDataCopy = cloneDeep(previewData);
    previewDataCopy[index].list[idx].urlList.splice(i, 1);
    setPreviewData(previewDataCopy);
    baseForm.validateFields(["previewFormData"]);
  };
  // 预览图新增
  const previewImgChange = (info: UploadChangeParam<UploadFile>, index: number, idx: number) => {
    const previewDataCopy = cloneDeep(previewData);
    if (info.file.status === "uploading") {
      previewDataCopy[index].list[idx].loading = true;
      setPreviewData(previewDataCopy);
      return;
    } else {
      previewDataCopy[index].list[idx].loading = false;
      setPreviewData(previewDataCopy);
    }
    if (info.file.status === "done") {
      if (info.file.response.code === 200) {
        previewDataCopy[index].list[idx].urlList.push({
          id: info?.file?.response?.data?.id,
          url: info?.file?.response?.data?.url,
          loading: false,
        });
        previewDataCopy[index].list[idx].loading = false;
        setPreviewData(previewDataCopy);
      } else {
        message.error(info.file.response.msg);
      }
    } else {
      setPreviewData(previewDataCopy);
    }
    baseForm.validateFields(["previewFormData"]);
  };
  // 软件包上传前处理
  const packageBeforeUpload = (file: RcFile) => {
    return new Promise<void>((resolve, reject) => {
      const isSizeOk = file.size <= typeItem.packageMaxSize;
      const subType = detailData.current?.subType || [];
      let arr = [];
      if (typeItem.packageNameEnd) {
        if (Array.isArray(typeItem.packageNameEnd)) {
          arr = typeItem.packageNameEnd;
        } else if (
          typeof typeItem.packageNameEnd === "object" &&
          typeItem.packageNameEnd !== null &&
          !!subType.length
        ) {
          arr = typeItem.packageNameEnd[subType[0]];
        }
      } else {
        arr = subType.map((item: string) => `.${item.toLowerCase()}`);
      }
      const isFileTypeOk = arr.some((item: string) => {
        const regex = new RegExp(`${item}$`, "i");
        return regex.test(file.name);
      });

      if (!isFileTypeOk) {
        const errorTip =
          packageTypeErrPrefix +
          (typeItem.subType && typeItem.subType[subType[0]] ? typeItem.subType[subType[0]] : arr.join("/")) +
          packageTypeErrSuffix;
        message.error(errorTip);
        reject();
        return;
      }

      if (!isSizeOk) {
        const tabsList = Object.values(app_detail.type_obj).map((item: any) => {
          return {
            key: item.key,
            label: item.label,
            permissions: item.permissions,
          };
        });
        if (type === tabsList[0].key) {
          if (file.name.endsWith(".hap")) {
            message.error(typeItem.hapPackageSizeErr);
            reject();
            return;
          } else {
            message.error(typeItem.appPackageSizeErr);
            reject();
            return;
          }
        } else {
          message.error(packageSizeErr);
          reject();
          return;
        }
      }

      // 类型和大小都对了就结合包类型给type赋值
      const nameSplitArr = file.name.split(".");
      const typeName = nameSplitArr[nameSplitArr.length - 1];
      const typeReq = typeName.toUpperCase();
      packageType.current = typeReq;

      resolve();
    });
  };
  // 上传软件包
  const packageReq = async (options: any) => {
    setPackageLoading(true);
    const { file } = options;

    setPackageData({ ...packageData, name: file.name });

    const formData = new FormData();
    formData.append("file", file);
    formData.append("appId", id!);
    formData.append("type", packageType.current);
    formData.append("subType", packageType.current);
    try {
      api
        .uploadFile(formData, id, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          // 上传进度回调
          onUploadProgress: (progressEvent: any) => {
            if (progressEvent?.progress) {
              const progressNumber = Math.floor(progressEvent?.progress * 100);
              setUploadProgress(progressNumber);
            }
          },
          errorIntercept: true,
        })
        .then((res: any) => {
          if (res.code !== 200) {
            message.error(res.msg);
            versionForm.setFieldValue("instanceIds", null);
          } else {
            setPackageData(res.data);
            versionForm.setFieldValue("instanceIds", res.data);
          }
        })
        .catch((err: any) => {
          message.error(err?.response?.data?.msg || release.upload_fail);
        })
        .finally(() => {
          setPackageLoading(false);
          versionForm.validateFields(["instanceIds"]);
          setUploadProgress(0);
        });
    } catch (err) {
      console.error(err);
      setPackageLoading(false);
    }
  };
  // 删除软件包
  const packageDel = () => {
    setPackageData(null);
    versionForm.setFieldValue("instanceIds", null);
    versionForm.validateFields(["instanceIds"]);
  };
  // 更换版权证书
  const copyrightImgUpdate = (info: UploadChangeParam<UploadFile>, index: number) => {
    const copyrightImageCopy = cloneDeep(copyrightImage);
    if (info.file.status === "uploading") {
      copyrightImageCopy[index].loading = true;
      setCopyrightImage(copyrightImageCopy);
      return;
    } else {
      copyrightImageCopy[index].loading = false;
      setCopyrightImage(copyrightImageCopy);
    }
    if (info.file.status === "done") {
      if (info.file.response.code === 200) {
        copyrightImageCopy[index].id = info?.file?.response?.data?.id;
        copyrightImageCopy[index].url = info?.file?.response?.data?.url;
        copyrightImageCopy[index].type = info?.file.response?.data?.type;
        copyrightImageCopy[index].loading = false;
        setCopyrightImage(copyrightImageCopy);
        versionForm.setFieldValue("copyright", copyrightImageCopy);
      } else {
        message.error(info.file.response.msg);
      }
    } else {
      versionForm.setFieldValue("copyright", copyrightImageCopy);
    }
    versionForm.validateFields(["copyright"]);
  };
  // 删除版权证书
  const copyrightImgDelete = (index: number) => {
    const copyrightImageCopy = cloneDeep(copyrightImage);
    copyrightImageCopy.splice(index, 1);
    setCopyrightImage(copyrightImageCopy);
    versionForm.setFieldValue("copyright", copyrightImageCopy);
    versionForm.validateFields(["copyright"]);
  };
  // 上传版权证书
  const copyrightImgChange = (info: UploadChangeParam<UploadFile>) => {
    if (info.file.status === "uploading") {
      setCopyrightLoading(true);
      return;
    } else {
      setCopyrightLoading(false);
    }
    if (info.file.status === "done") {
      if (info.file.response.code === 200) {
        const copyrightImageCopy = cloneDeep(copyrightImage);
        copyrightImageCopy.push({
          id: info?.file?.response?.data?.id,
          url: info?.file?.response?.data?.url,
          type: info?.file.response?.data?.type,
        });
        setCopyrightLoading(false);
        setCopyrightImage(copyrightImageCopy);
        versionForm.setFieldValue("copyright", copyrightImageCopy);
      } else {
        message.error(info.file.response.msg);
      }
    }
    versionForm.validateFields(["copyright"]);
  };

  const commitmentLetter = () => {
    Modal.info({
      icon: <span></span>,
      okText: confirmText,
      content: (
        <>
          <div style={{ textAlign: "center", fontSize: "24px" }}>{release.commitment_letter_text}</div>
          <div>{release.commitment_letter_content1}</div>
          <div>{release.commitment_letter_content2}</div>
        </>
      ),
    });
  };

  const getDomain = async () => {
    try {
      const res: any = await api.getNewDict("DOMAIN");
      if (res?.code == 200) {
        const arr = res.data["DOMAIN"].filter(
          (item: any) => item.dictValue !== "ALL" && item.dictValue !== "ALL_DOMAIN"
        );
        setDomainOption(arr);
      } else {
        message.error(res.msg);
      }
    } catch (errorInfo: any) {
      message.error(errorInfo?.response?.data?.msg || req_err);
    }
  };
  const domainAndTopic = async () => {
    const topicList: any = await getOptions(typeItem.topicApiParam);
    setTopicOption(topicList);
    const kaihongOSVersionList: any = await getOptions(typeItem.kaihongOSVersion);
    setKaihongOSVersionOption([
      ...kaihongOSVersionList,
      {
        dictLabel: "不涉及",
        dictCode: "NO_RELATE",
      },
    ]);
  };

  // 应用领域、应用专题下拉项
  const getOptions = async (type: string) => {
    try {
      console.log(type, "---");
      const arr = ["DOMAIN", "TOPIC", "AI_MODEL_INDUSTRY", "SUPPORT_CHIP", "RULE_ENGINE_INDUSTRY", "SUPPORT_PROTOCOL"];
      let res: any;
      if (arr.includes(type)) {
        res = await api.getNewDict(type);
      } else {
        res = await api.getDict(type);
      }
      if (res?.code == 200) {
        console.log(res, "999");
        const list = arr.includes(type)
          ? res?.data?.[type].filter((item: any) => item.dictValue !== "ALL")
          : res?.data?.value;
        return list || [];
      } else {
        message.error(res.msg);
        return [];
      }
    } catch (errorInfo: any) {
      message.error(errorInfo?.response?.data?.msg || req_err);
      return [];
    }
  };

  // 校验是否有图片正在上传
  const checkIsImgUploading = () => {
    const previewDataCopy = cloneDeep(previewData);
    const previewLoading = previewDataCopy.some((item: any) => {
      const addLoading = item.list.some((ele: any) => {
        return ele.loading;
      });
      if (addLoading) {
        return true;
      } else {
        const updateLoading = item.list.some((ele: any) => {
          return ele.urlList.some((e: any) => {
            return e.loading;
          });
        });
        return updateLoading;
      }
    });
    return iconLoading || previewLoading || copyrightLoading;
  };

  const useFetchSelectOptions = (customItem: CustomItem) => {
    const [options, setOptions] = useState<any[]>([]);

    useEffect(() => {
      let isMounted = true;
      const fetchOptions = async () => {
        // 优先使用本地optionConfig
        if (customItem?.optionConfig && customItem.optionConfig.length) {
          setOptions(customItem.optionConfig);
          return;
        }
        // 无本地配置则请求接口
        if (!customItem.apiConfig?.url) return;

        try {
          const method = (customItem.apiConfig.method || "get").toLowerCase();
          let res: any;
          if (method === "get") {
            res = await http.get(customItem.apiConfig.url, { params: customItem.apiConfig.data || {} });
          } else if (method === "post") {
            res = await http.post(customItem.apiConfig.url, customItem.apiConfig.data || {});
          } else {
            res = await http({
              method: customItem.apiConfig.method,
              url: customItem.apiConfig.url,
              data: customItem.apiConfig.data || {},
            });
          }
          if (isMounted && res?.code === 200) {
            setOptions(res?.data?.value || []);
          } else if (isMounted) {
            message.error(res?.msg || "请求失败");
          }
        } catch (errorInfo: any) {
          if (isMounted) {
            message.error(errorInfo?.response?.data?.msg || "请求出错");
          }
        }
      };

      fetchOptions();
      return () => {
        isMounted = false;
      };
    }, [
      customItem?.optionConfig,
      customItem?.apiConfig?.url,
      customItem?.apiConfig?.method,
      customItem?.apiConfig?.data,
    ]);

    return options;
  };

  const RenderCustomCompenent = ({ customItem, value, onChange }: RenderCustomCompenentProps) => {
    if (!customItem) return null;
    const mapLabel = customItem?.mapConfig?.label || "dictLabel";
    const mapValue = customItem?.mapConfig?.value || "dictCode";

    const options = useFetchSelectOptions(customItem);

    switch (customItem.type) {
      case "select":
        return (
          <Select
            showSearch
            options={options}
            placeholder={please_choose}
            fieldNames={{ label: mapLabel, value: mapValue }}
            filterOption={(input, option) => (option?.[mapLabel] ?? "").toLowerCase().includes(input.toLowerCase())}
            style={{ width: 524 }}
            title={mapLabel}
            value={value}
            onChange={onChange}
          />
        );
      case "input":
        return (
          <Input
            placeholder={please_enter}
            showCount
            maxLength={30}
            style={{ width: 524 }}
            value={value}
            onChange={(e) => onChange?.(e.target.value)}
          />
        );
      default:
        return null;
    }
  };

  // const customContent = detailData.current?.customContent;
  const CustomFormItems = useMemo(() => {
    console.log(customContent, "111");
    if (!customContent || !customContent.length) {
      return null;
    }

    return customContent.map((item: CustomItem) => {
      return (
        <Form.Item
          label={item.label}
          name={item.key}
          rules={[
            {
              required: true,
              message: item.type === "select" ? please_choose : please_enter,
            },
          ]}
          key={item.key}
        >
          <RenderCustomCompenent customItem={item} />
        </Form.Item>
      );
    });
  }, [customContent]);

  useEffect(() => {
    const tableDataCopy = cloneDeep(tableData);
    const tableChecks = tableDataCopy.filter((item: any) => selectedKeys?.includes(item.key));
    const allCompatibleDevices = tableChecks.reduce((pre: any, cur: any) => {
      return [...pre, ...cur.compatibleDevices];
    }, []);

    if (allCompatibleDevices?.length === 1) {
      for (let index = 0; index < tableDataCopy.length; index++) {
        const element = tableDataCopy[index];
        if (element?.compatibleDevices[0] === allCompatibleDevices[0]) {
          for (let ind = 0; ind < element?.options?.length; ind++) {
            const item = element.options[ind];
            if (item.dictCode === allCompatibleDevices[0] && !item?.disabled) {
              tableDataCopy[index].options[ind].disabled = true;
              setTableData(tableDataCopy);
              break;
            }
          }
          break;
        }
      }
    } else {
      for (let index = 0; index < tableDataCopy.length; index++) {
        const element = tableDataCopy[index];
        for (let ind = 0; ind < element?.options?.length; ind++) {
          const item = element.options[ind];
          if (item?.disabled) {
            tableDataCopy[index].options[ind].disabled = false;
            setTableData(tableDataCopy);
          }
        }
      }
    }

    const effectiveData = tableData.filter(
      (item: any) => item?.compatibleDevices?.length && selectedKeys.includes(item.key)
    );
    const newPreviewData = effectiveData.map((item: any) => {
      const effectiveOption = item?.options.filter((ele: any) => item.compatibleDevices.includes(ele.dictCode));

      const list = effectiveOption.map((ele: any) => {
        const previewItem = preview.current.find((e: any) => e.key == ele.dictType);
        const previewListItem = previewItem?.list?.find((e: any) => e.dictCode == ele.dictCode);
        const newUrlList = previewListItem?.urlList || [];

        return {
          dictCode: ele?.dictCode,
          dictValue: ele?.dictValue,
          dictLabel: ele?.dictLabel,
          description: previewListItem?.description,
          osIds: previewListItem?.osIds || [],
          loading: false,
          urlList: newUrlList,
        };
      });
      return {
        key: item?.key,
        title: item?.title,
        list,
      };
    });

    setPreviewData(newPreviewData);
  }, [selectedKeys, tableData]);

  useEffect(() => {
    if (releaseDetail) {
      const resData = cloneDeep(releaseDetail);

      const resShowMode = findDeep(release.show_mode_arr, resData?.showMode);

      const nowIndex = resData?.histories.findIndex((item: any) => item.id == resData.id);
      if (nowIndex === 0) {
        //最新版本
        if (resShowMode?.isUpgrade && resData?.histories?.length > 1) {
          // 有升级场景，在新版本页面，按钮要受到旧版本状态影响
          const oldShowMode = resData?.histories[1]?.showMode;
          resData.baseBtns = resShowMode?.btnsByOld[oldShowMode];
        } else {
          resData.baseBtns = resShowMode?.baseBtns;
        }
      } else if (nowIndex === 1) {
        //旧版本
        if (resShowMode?.btnsByNew && resData?.histories?.length > 1) {
          // 有升级场景，在旧版本页面，按钮要受到新版本状态影响
          resData.baseBtns = resShowMode?.btnsByNew[resShowMode];
        } else {
          resData.baseBtns = resShowMode?.baseBtns;
        }
      } else {
        // 历史版本
        resData.baseBtns = resShowMode?.baseBtns;
      }

      resData.showModeLabel = resShowMode?.title;
      resData.isUpgrade = !!resShowMode?.isUpgrade;

      if (resData?.appInstances[0]?.version) {
        resData.showModeLabel = resData?.appInstances[0]?.version + one_bars + resShowMode?.title;
      } else {
        resData.showModeLabel = app_detail.new_version + one_bars + resShowMode?.title;
      }
      // 当存在两个版本时候，旧版本都不可修改
      if (resData?.histories?.length > 1 && resData?.histories[1]?.id === id) {
        resData.disabled = true;
      } else {
        resData.disabled = resShowMode?.formDisabled;
      }

      resData.packageDisabled =
        resShowMode?.packageDisabled || (resShowMode?.modeObj && resShowMode?.modeObj[resData.mode]?.packageDisabled);
      resData.allowChangePackageList =
        resShowMode?.allowChangePackageList ||
        (resShowMode?.modeObj && resShowMode?.modeObj[resData.mode]?.allowChangePackageList);

      resData.opinion = resShowMode?.opinion;

      resData.modeTypeText = resData.typeKeyInfo.name;

      resData.titleDescriptionLabel = resShowMode?.titleDescription
        ? resShowMode?.pleaseWrite
          ? resShowMode?.pleaseWrite + resData.typeKeyInfo.name + resShowMode?.titleDescription
          : resData.typeKeyInfo.name + resShowMode?.titleDescription
        : "";
      resData.packageStr = resData.subType.join("/");
      resData.customContent = parseResponseToArray(resData.typeKeyInfo.customJson);
      setCustomContent(parseResponseToArray(resData.typeKeyInfo.customJson));
      detailData.current = resData;

      domainAndTopic();
      getSupportOptions();
    }
  }, [releaseDetail]);

  useEffect(() => {
    // antd Form.useWatch 不支持“监听一组字段数组”的语义；这里用全量 watch 来驱动 effect，
    // 但校验时只校验 baseFinishFields，避免无关字段影响完成态。
    baseForm
      .validateFields(baseFinishFields, { validateOnly: true })
      .then(() => setIsBaseFinish(true))
      .catch(() => setIsBaseFinish(false));
  }, [baseFormValues, baseFinishFields, baseForm]);
  useEffect(() => {
    const khId = versionFormValues?.kaihongOSVersionId;
    const fields: string[] = ["kaihongOSVersionId"];
    if (khId !== undefined && khId !== "NO_RELATE") {
      fields.push("kaihongOSVersionType");
    }
    fields.push("privacy", "copyright", "commitmentAgree");
    versionForm
      .validateFields(fields, { validateOnly: true })
      .then(() => setIsVersionFinish(true))
      .catch(() => setIsVersionFinish(false));
  }, [versionFormValues, versionForm]);
  useEffect(() => {
    setPreviewCurrent(previewData);
    baseForm.setFieldValue("previewFormData", previewData);
  }, [previewData]);

  useEffect(() => {
    getDomain();
  }, []);

  const kaihongOSVersionId = Form.useWatch("kaihongOSVersionId", versionForm);

  const isShow = useMemo(() => kaihongOSVersionId !== "NO_RELATE", [kaihongOSVersionId]);

  return (
    <div className={`appDetail-content ${prefix}`}>
      <div className={`${prefix}-header`}>
        <div className={`${prefix}-header-left`}>
          <div title={detailData.current?.showModeLabel} className="one-line-ellipsis">
            {detailData.current?.showModeLabel}
          </div>
          {detailData.current?.titleDescriptionLabel ? <div>{detailData.current?.titleDescriptionLabel}</div> : null}
          <div className="one-line-ellipsis" title={detailData.current?.opinion || detailData.current?.audit?.content}>
            <span>{release.review_comments}</span>
            {detailData.current?.opinion || detailData.current?.audit?.content || two_bars}
          </div>
        </div>
        <div>
          {detailData.current?.baseBtns?.map((item: string) => {
            return <span key={item}>{renderBtn(item)}</span>;
          })}
        </div>
      </div>
      <div className={`${prefix}-content`}>
        <Tabs
          activeKey={activeKey}
          renderTabBar={renderTabBar}
          indicator={{ size: (origin) => origin - 19, align: "start" }}
          onChange={onChange}
          className={`${prefix}-tabs`}
          items={[
            {
              key: release.tabs[0].key,
              forceRender: true,
              label: (
                <>
                  {release.tabs[0].label}
                  {<CheckCircleFilled style={{ color: isBaseFinish ? "#3EC167" : "#8C8C8C", marginLeft: 4 }} />}
                </>
              ),
              children: (
                <Form
                  disabled={detailData.current?.disabled}
                  form={baseForm}
                  layout="vertical"
                  scrollToFirstError={true}
                  className={`${prefix}-baseForm ${prefix}-form`}
                >
                  <Form.Item
                    label={release.supported_devices_label}
                    name="previewFormData"
                    rules={[{ required: true, message: release.supported_devices_required }]}
                  >
                    <Table
                      columns={getTableColumns()}
                      dataSource={tableData}
                      pagination={false}
                      rowSelection={{
                        type: "checkbox",
                        hideSelectAll: detailData.current?.disabled,
                        ...rowSelection,
                      }}
                    />
                  </Form.Item>
                  <Form.Item
                    label={detailData.current?.modeTypeText + release.name_label}
                    name="name"
                    validateDebounce={500}
                    rules={[
                      { required: true, message: please_enter + detailData.current?.modeTypeText + name_label },
                      {
                        pattern: appNameReg,
                        message: app_detail.name_validator,
                      },
                      {
                        validator: validateName,
                      },
                    ]}
                    getValueFromEvent={(e) => e.target.value.replace(/(^\s*)|(\s*$)/g, "")}
                  >
                    <Input
                      placeholder={`${please_enter}${detailData.current?.modeTypeText}${name_label}`}
                      showCount
                      maxLength={30}
                      style={{ width: 524 }}
                    />
                  </Form.Item>
                  <Form.Item
                    label={release.introduction}
                    name="introduction"
                    validateDebounce={500}
                    rules={[{ required: true, message: release.introduction_required }]}
                    getValueFromEvent={(e) => e.target.value.replace(/(^\s*)|(\s*$)/g, "")}
                  >
                    <Input
                      placeholder={release.introduction_required}
                      showCount
                      maxLength={30}
                      style={{ width: 524 }}
                    />
                  </Form.Item>

                  <Form.Item
                    label={release.description_label}
                    name="description"
                    rules={[
                      {
                        required: true,
                        message: `${please_enter}${description_label}`,
                      },
                    ]}
                    getValueFromEvent={(e) => e.target.value.replace(/(^\s*)|(\s*$)/g, "")}
                  >
                    <Input.TextArea
                      placeholder={`${please_enter}${description_label}`}
                      showCount
                      maxLength={300}
                      autoSize={{ minRows: 4, maxRows: 6 }}
                      style={{ width: 524 }}
                    />
                  </Form.Item>
                  <Form.Item
                    label={release.icon_label}
                    name="iconResources"
                    rules={[
                      { required: true, message: `${please_upload}${detailData.current?.modeTypeText}${icon_text}` },
                    ]}
                    className={`${prefix}-baseForm-iconResources`}
                  >
                    <div>
                      <div className={`${prefix}-form-tip`}>{release.icon_tip}</div>
                      <Upload
                        accept="image/*"
                        listType="picture-card"
                        showUploadList={false}
                        disabled={detailData.current?.disabled || iconLoading}
                        maxCount={1}
                        action={uploadUrl}
                        headers={{
                          Authorization: getAuthTokenValue("Authorization") || "",
                        }}
                        data={{
                          appId: id,
                          type: "ICON",
                          subType: "ICON",
                        }}
                        beforeUpload={async (e) => {
                          await beforeUpload(e, { width: 256, height: 256, size: 3145728, accept: ["png"] });
                        }}
                        onChange={iconImageChange}
                        style={{ margin: 0 }}
                      >
                        {iconImageUrl ? (
                          <img src={iconImageUrl} alt="avatar" />
                        ) : iconLoading ? (
                          <LoadingOutlined />
                        ) : (
                          <PlusSquareFilled className={`${prefix}-add-icon`} />
                        )}
                      </Upload>
                    </div>
                  </Form.Item>
                  {/* 运营平台配置的特定字段表单*/}
                  {CustomFormItems}
                  <Form.Item
                    label={release.domain_label}
                    name="domain"
                    rules={[{ required: true, message: release.domain_required }]}
                  >
                    <Select
                      showSearch
                      options={domainOption}
                      placeholder={release.domain_required}
                      fieldNames={{ label: "dictLabel", value: "dictCode" }}
                      filterOption={(input, option) =>
                        (option?.dictLabel ?? "").toLowerCase().includes(input.toLowerCase())
                      }
                      style={{ width: 524 }}
                    />
                  </Form.Item>
                  <Form.Item
                    label={release.topic_label}
                    name="topic"
                    rules={[{ required: true, message: release.topic_required }]}
                  >
                    <Select
                      mode="multiple"
                      options={topicOption}
                      placeholder={release.topic_required}
                      fieldNames={{ label: "dictLabel", value: "dictCode" }}
                      filterOption={(input, option) =>
                        (option?.dictLabel ?? "").toLowerCase().includes(input.toLowerCase())
                      }
                      style={{ width: 524 }}
                    />
                  </Form.Item>
                  <Form.Item
                    label={release.system_label}
                    name="system"
                    rules={[{ required: true, message: release.system_required }]}
                  >
                    <Select
                      mode="multiple"
                      options={systemOptions}
                      placeholder={release.system_required}
                      fieldNames={{ label: "dictLabel", value: "dictCode" }}
                      filterOption={(input, option) =>
                        (option?.dictLabel ?? "").toLowerCase().includes(input.toLowerCase())
                      }
                      style={{ width: 524 }}
                    />
                  </Form.Item>
                  <Form.Item
                    label={release.preview_screenshot_label}
                    shouldUpdate={(prevValues, curValues) => prevValues.previewFormData !== curValues.previewFormData}
                    rules={[{ required: true }]}
                  >
                    {({ getFieldValue }) => {
                      const pFormData: any[] = getFieldValue("previewFormData") || [];
                      return (
                        <div>
                          <div className={`${prefix}-form-tip`}>{release.preview_screenshot_tip}</div>
                          {pFormData.map((item, index) => (
                            <div key={item.key} className={`${prefix}-screenshot`}>
                              <div className={`${prefix}-screenshot-title`}>{item.title}：</div>
                              {item.list.map((ele: any, idx: number) => {
                                return (
                                  <div key={ele.dictCode} className={`${prefix}-screenshot-device`}>
                                    <div className={`${prefix}-screenshot-device-title`}>{ele.dictLabel}：</div>
                                    {ele.urlList.map((e: any, i: number) => {
                                      return (
                                        <div key={e.id} className={`${prefix}-upload-img`}>
                                          {detailData.current?.disabled ? null : (
                                            <CloseCircleFilled
                                              className={`${prefix}-upload-img-del`}
                                              onClick={() => {
                                                previewImgDelete(index, idx, i);
                                              }}
                                            />
                                          )}

                                          <Upload
                                            accept="image/*"
                                            listType="picture-card"
                                            showUploadList={false}
                                            disabled={detailData.current?.disabled || e.loading}
                                            maxCount={1}
                                            action={uploadUrl}
                                            headers={{
                                              Authorization: getAuthTokenValue("Authorization") || "",
                                            }}
                                            data={{
                                              appId: id,
                                              subType: ele.dictValue,
                                              type: "PREVIEW_PICTURE",
                                            }}
                                            beforeUpload={async (e) => {
                                              await beforeUpload(e, {
                                                width: 1800,
                                                height: 920,
                                                size: 3145728,
                                                accept: ["jpg", "jpeg", "png"],
                                              });
                                            }}
                                            onChange={(e) => {
                                              previewImgUpdate(e, index, idx, i);
                                            }}
                                          >
                                            {e.loading ? <LoadingOutlined /> : <img src={e?.url} alt="avatar" />}
                                          </Upload>
                                        </div>
                                      );
                                    })}
                                    {ele.urlList?.length >= 10 ? null : (
                                      <Upload
                                        accept="image/*"
                                        listType="picture-card"
                                        className={`${prefix}-upload-imgAdd`}
                                        disabled={detailData.current?.disabled || ele.loading}
                                        action={uploadUrl}
                                        headers={{
                                          Authorization: getAuthTokenValue("Authorization") || "",
                                        }}
                                        data={{
                                          appId: id,
                                          subType: ele.dictValue,
                                          type: "PREVIEW_PICTURE",
                                        }}
                                        showUploadList={false}
                                        beforeUpload={async (e) => {
                                          await beforeUpload(e, {
                                            width: 1800,
                                            height: 920,
                                            size: 3145728,
                                            accept: ["jpg", "jpeg", "png"],
                                          });
                                        }}
                                        onChange={(e) => {
                                          previewImgChange(e, index, idx);
                                        }}
                                      >
                                        {ele.loading ? (
                                          <LoadingOutlined />
                                        ) : (
                                          <PlusSquareFilled className={`${prefix}-add-icon`} />
                                        )}
                                      </Upload>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          ))}
                        </div>
                      );
                    }}
                  </Form.Item>
                  <Form.Item
                    name="previewFormData"
                    className={`${prefix}-hidden`}
                    rules={[
                      { required: true, message: release.preview_screenshot_required },
                      ({ getFieldValue }) => ({
                        async validator() {
                          const previewList = getFieldValue("previewFormData");
                          const validatorSuccess = previewList?.every((item: any) => {
                            const listSuccess = item.list.every((ele: any) => {
                              return ele.urlList?.length > 0;
                            });
                            return listSuccess;
                          });
                          if (!validatorSuccess) {
                            return Promise.reject(new Error(release.preview_screenshot_validator));
                          } else {
                            return Promise.resolve();
                          }
                        },
                      }),
                    ]}
                  >
                    <Input hidden />
                  </Form.Item>
                </Form>
              ),
            },
            {
              key: release.tabs[1].key,
              forceRender: true,
              label: (
                <>
                  {release.tabs[1].label}
                  {<CheckCircleFilled style={{ color: isVersionFinish ? "#3EC167" : "#8C8C8C", marginLeft: 4 }} />}
                </>
              ),
              children: (
                <Form
                  form={versionForm}
                  disabled={detailData.current?.disabled}
                  layout="vertical"
                  scrollToFirstError={true}
                  className={`${prefix}-versionForm ${prefix}-form`}
                >
                  <Form.Item
                    label={release.package_label}
                    name="instanceIds"
                    rules={[{ required: true, message: release.package_required }]}
                    className={`${prefix}-versionForm-packageResources`}
                  >
                    <div>
                      <div className={`${prefix}-form-tip`}>
                        {typeItem?.packageTipPrefix
                          ? typeItem?.packageTipPrefix + detailData.current?.packageStr + typeItem?.packageTipSuffix
                          : typeof typeItem?.packageTip === "string"
                          ? typeItem?.packageTip
                          : typeItem?.packageTip[detailData.current?.subType[0]]}
                      </div>
                      {packageData?.resourceId ? (
                        <div className={`${prefix}-package-data`} style={{ width: 524 }}>
                          <span title={packageData?.name} className="one-line-ellipsis">
                            {packageData?.name}
                          </span>
                          <span title={packageData?.version} className="one-line-ellipsis">
                            {packageData?.version}
                          </span>
                          <span>{format(new Date(Number(packageData?.createTime)), "yyyy/MM/dd-HH:mm:ss")}</span>
                          <span>{changeSize(packageData?.length)}</span>
                          {detailData.current?.disabled || detailData.current?.packageDisabled ? null : (
                            <CloseCircleFilled
                              style={{ color: "#000", cursor: "pointer" }}
                              className={`${prefix}-package-del`}
                              onClick={packageDel}
                            />
                          )}
                        </div>
                      ) : packageLoading ? (
                        <div className={`${prefix}-package-loading`} style={{ width: 524 }}>
                          <span title={packageData?.name} className="one-line-ellipsis">
                            {packageData?.name}
                          </span>
                          {uploadProgress < 100 ? (
                            <span>
                              {release.uploading_label}
                              <Progress type="circle" size={30} percent={uploadProgress} />
                            </span>
                          ) : (
                            <span>
                              {release.analysising_label}
                              <LoadingOutlined style={{ color: "#0A59F7", fontSize: 30 }} />
                            </span>
                          )}
                        </div>
                      ) : (
                        <Upload
                          beforeUpload={packageBeforeUpload}
                          customRequest={packageReq}
                          showUploadList={false}
                          style={{ margin: 0 }}
                        >
                          <div className={`${prefix}-package-add`}>
                            <CloudUploadOutlined className={`${prefix}-package-cloud`} />
                            <PlusSquareFilled className={`${prefix}-package-plus`} />
                          </div>
                        </Upload>
                      )}
                    </div>
                  </Form.Item>
                  <Divider />
                  <Form.Item
                    label={
                      <span>
                        <span className={`${prefix}-required-extra`}>*</span>
                        {release.systemVersion_label}
                      </span>
                    }
                  >
                    <Form.Item
                      name="kaihongOSVersionId"
                      rules={[{ required: true, message: release.systemVersion_required }]}
                      style={{ display: "inline-block", marginBottom: 0 }}
                    >
                      <Select
                        showSearch
                        options={kaihongOSVersionOption}
                        placeholder={release.systemVersion_required}
                        fieldNames={{ label: "dictLabel", value: "dictCode" }}
                        filterOption={(input, option) =>
                          (option?.dictLabel ?? "").toLowerCase().includes(input.toLowerCase())
                        }
                        style={{ width: 300 }}
                      />
                    </Form.Item>
                    {isShow && (
                      <Form.Item
                        name="kaihongOSVersionType"
                        rules={[{ required: true, message: release.kaihongOSVersion_type_required }]}
                        style={{ display: "inline-block", marginLeft: 24, marginBottom: 0 }}
                      >
                        <Select
                          options={release.supportType_list}
                          placeholder={release.kaihongOSVersion_type_required}
                          style={{ width: 200 }}
                        />
                      </Form.Item>
                    )}
                  </Form.Item>
                  <Divider />
                  <Form.Item
                    label={release.privacy_label}
                    name="privacy"
                    rules={[
                      {
                        pattern: /(http|https):\/\/([\w.]+\/?)\S*/,
                        message: release.privacy_validator,
                      },
                    ]}
                    getValueFromEvent={(e) => e.target.value.replace(/(^\s*)|(\s*$)/g, "")}
                  >
                    <Input placeholder={release.privacy_placeholder} maxLength={1024} style={{ width: 524 }} />
                  </Form.Item>
                  <Divider />
                  <Form.Item label={release.copyright_message} className={`${prefix}-versionForm-version-tip`}>
                    <div className={`${prefix}-form-tip`}>{release.version_tip}</div>
                    <Form.Item
                      label={release.copyright_label}
                      name="copyright"
                      className={`${prefix}-versionForm-copyright`}
                      style={{ marginBottom: 0 }}
                    >
                      <div className="clearfix">
                        {copyrightImage?.map((item: any, index: number) => {
                          return (
                            <div key={item.id} className={`${prefix}-upload-img`}>
                              {detailData.current?.disabled ? null : (
                                <CloseCircleFilled
                                  className={`${prefix}-upload-img-del`}
                                  onClick={() => {
                                    copyrightImgDelete(index);
                                  }}
                                />
                              )}

                              <Upload
                                accept="image/*"
                                listType="picture-card"
                                className={`${prefix}-copyright-upload`}
                                disabled={detailData.current?.disabled || item.loading}
                                action={uploadUrl}
                                headers={{
                                  Authorization: getAuthTokenValue("Authorization") || "",
                                }}
                                data={{
                                  appId: id,
                                  type: "CERTIFICATE_PICTURE",
                                  subType: "CERTIFICATE_PICTURE",
                                }}
                                showUploadList={false}
                                onChange={(e) => {
                                  copyrightImgUpdate(e, index);
                                }}
                              >
                                {item.loading ? <LoadingOutlined /> : <img src={item?.url} alt="avatar" />}
                              </Upload>
                            </div>
                          );
                        })}
                        {copyrightImage?.length >= 10 ? null : (
                          <Upload
                            accept="image/*"
                            listType="picture-card"
                            className={`${prefix}-upload-imgAdd`}
                            disabled={detailData.current?.disabled || copyrightLoading}
                            action={uploadUrl}
                            headers={{
                              Authorization: getAuthTokenValue("Authorization") || "",
                            }}
                            data={{
                              appId: id,
                              type: "CERTIFICATE_PICTURE",
                              subType: "CERTIFICATE_PICTURE",
                            }}
                            showUploadList={false}
                            beforeUpload={copyrightBeforeUpload}
                            onChange={copyrightImgChange}
                          >
                            {copyrightLoading ? (
                              <LoadingOutlined />
                            ) : (
                              <PlusSquareFilled className={`${prefix}-add-icon`} />
                            )}
                          </Upload>
                        )}
                      </div>
                    </Form.Item>
                  </Form.Item>
                  <Divider />
                  <Form.Item
                    label={
                      <span>
                        <span className={`${prefix}-required-extra`}>*</span>
                        {release.commitment_letter_label}
                      </span>
                    }
                    className={`${prefix}-versionForm-agree`}
                  >
                    <div className={`${prefix}-agree-wrap`}>
                      <Form.Item
                        name="commitmentAgree"
                        valuePropName="checked"
                        noStyle
                        rules={[
                          {
                            validator: async (_rule, value) => {
                              if (value === true) return;
                              throw new Error(release.please_check_agree);
                            },
                          },
                        ]}
                      >
                        <Checkbox className={`${prefix}-agree-checkbox`}>
                          {release.read_agree}
                          <Button
                            type="link"
                            className={`${prefix}-agree-btn`}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              commitmentLetter();
                            }}
                          >
                            {release.commitment_letter_book}
                          </Button>
                        </Checkbox>
                      </Form.Item>
                    </div>
                  </Form.Item>
                </Form>
              ),
            },
          ]}
        />
      </div>
      <ApplyDown type={type} id={id} visible={applyDownVisible} close={applyDownClose} />
    </div>
  );
};

export default VersionManage;
